module.exports = __webpack_public_path__ + "static/media/DSCN03391.77e0a514.jpg";